// extracted by mini-css-extract-plugin
export default {"best":"product-gbb__best___fjpN4","better":"product-gbb__better___18ac4","bettr":"product-gbb__bettr___2pOJY","good":"product-gbb__good___1bv6I"};